import highchartsPluginRegistry from "../../HighchartsPluginRegistry"
import chartPlugin from "./chartPlugin"
import legendPlugin from "./legendPlugin"
import xAxisPlugin from "./xAxisPlugin"
import yAxisPlugin from "./yAxisPlugin"
import disableNavigator from "./navigatorPlugin"
import rangeSelectorPlugin from "./rangeSelectorPlugin"
import plotOptionsPlugin from "./plotOptionsPlugin"
import tooltipPlugin from "./tooltipPlugin"
import miscellaneousPlugin from "./miscellaneousPlugin"

/**
 * Register custom plugin
 */
export function registerWidgetPlugins() {
  highchartsPluginRegistry.register("chartPlugin", chartPlugin)
  highchartsPluginRegistry.register("legendPlugin", legendPlugin)
  highchartsPluginRegistry.register("xAxisPlugin", xAxisPlugin)
  highchartsPluginRegistry.register("yAxisPlugin", yAxisPlugin)
  highchartsPluginRegistry.register("disableNavigator", disableNavigator)
  highchartsPluginRegistry.register("rangeSelectorPlugin", rangeSelectorPlugin)
  highchartsPluginRegistry.register("plotOptionsPlugin", plotOptionsPlugin)
  highchartsPluginRegistry.register("tooltipPlugin", tooltipPlugin)
  highchartsPluginRegistry.register("miscellaneousPlugin", miscellaneousPlugin)
}

export function clearWidgetPlugins() {
  highchartsPluginRegistry.remove("chartPlugin")
  highchartsPluginRegistry.remove("legendPlugin")
  highchartsPluginRegistry.remove("xAxisPlugin")
  highchartsPluginRegistry.remove("yAxisPlugin")
  highchartsPluginRegistry.remove("disableNavigator")
  highchartsPluginRegistry.remove("rangeSelectorPlugin")
  highchartsPluginRegistry.remove("plotOptionsPlugin")
  highchartsPluginRegistry.remove("tooltipPlugin")
  highchartsPluginRegistry.remove("miscellaneousPlugin")
}
